const CONFIG = {
  API_URL: process.env.GATSBY_API_URL || '/api',
  BLOG_URL: process.env.GATSBY_BLOG_URL || '/blog',
  DASHBOARD_URL: process.env.GATSBY_DASHBOARD_URL || '/dashboard',
  MARKETING_URL: process.env.GATSBY_MARKETING_URL || '/',
  RAF_VOUCHER_VALUE: process.env.GATSBY_RAF_VOUCHER_VALUE,
  SMARTY_ENV: process.env.GATSBY_SMARTY_ENV,
  VERSION: process.env.GATSBY_VERSION,
  COMMIT: process.env.GATSBY_COMMIT,
}

// Env vars are strings - so we need to check that vars are defined and that the string is `true`
const FEATURES = {
  REFER_AND_EARN: process.env.GATSBY_FEATURE_REFER_AND_EARN === 'true',
  SHORT_CODES: process.env.GATSBY_FEATURE_SHORTCODES === 'true',
  VAT_UPDATE: process.env.GATSBY_FEATURE_VAT_UPDATE === 'true',
}

export { CONFIG, FEATURES }
